module.exports = __webpack_public_path__ + "static/media/vn.406a863c.svg";